module.exports = __webpack_public_path__ + "static/discourses-on-livy-5cf3431a4b1cdf09f7e95f992c1ed263.jpg";